import axios from "axios";
import {toast} from "react-toastify";
import React, {useState, useContext} from "react";
import FeatherIcon from "feather-icons-react";
import {ReactComponent as GoogleSvg} from "../images/google.svg";
import {LoginSocialGoogle} from "reactjs-social-login";
import {useTranslation} from "react-i18next";
import AuthContext from "../contexts/AuthContext";

const GoogleAuth = () => {
    const { t } = useTranslation();
    let [googleLoader, setGoogleLoader] = useState(false);
    const { socialLoginUser } = useContext(AuthContext);

    const Auth = async (data) => {
        try {
            setGoogleLoader(true);
            const token = data.id_token || data.credential || data.access_token;
            await socialLoginUser('google', token, data);
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setTimeout(() => {setGoogleLoader(false)}, 200)
        }

    }
    return <LoginSocialGoogle
        client_id={"236899298385-orch55t5vhpb1keheck5q40h0nk8gdo9.apps.googleusercontent.com"}
        scope="openid profile email"
        discoveryDocs="clams supported"
        isOnlyGetToken={true}
        onResolve={({provider,data}) => {Auth(data);}}
        onReject={(err) => { console.error("Google Auth Reject:", err); }}
    >
        <div className="google" id="google-signin">
            {
                googleLoader ?
                    <>
                        <FeatherIcon icon="loader" />
                        {t("Loading")}...
                    </>
                    :
                    <> <GoogleSvg />
                        <span>{t("Sign in with")} </span> {t("Google")}
                    </>
            }

        </div>
    </LoginSocialGoogle>
}

export default GoogleAuth